<div class="select-ns-group-row">
  <input #inputCheck
         class="server-name"
         value="{{ getNsGroupNameById(inputValue)}} - {{inputSubnetworkId }}"
         [disabled]="inputIsDisable"
         [hidden]="inputIsHidden"/>

  <div class="modify-live-search"
       *ngIf="allNsGroups.length > 0 && !selectIsHidden">
    <div class="info-content">
      <div class="widget-inner-content">
        <ngx-select [allowClear]="true"
                    [items]="allNsGroups"
                    optionValueField="id"
                    optionTextField="text"
                    (select)="selectedNsGroup($event)"
                    (remove)="removed($event)">
        </ngx-select>
      </div>
    </div>
    <div class="info-content">
      <div class="widget-inner-title">Subnet Prefix:
        <i class="fa fa-info-circle info-text"></i>
      </div>
      <div class="widget-inner-content">
        <input #inputCheckSubnwkId
               [ngClass]="{'ng-invalid': haveError }"
               value="{{inputSubnetworkId}}"
               class="server-name"
               (input)="testValidation(inputCheckSubnwkId.value, inputCheckSubnwkId, $event)"
               (change)="testValidation(inputCheckSubnwkId.value, inputCheckSubnwkId, $event)"
               (keydown)="testValidation(inputCheckSubnwkId.value, inputCheckSubnwkId, $event)"
               (keyup)="testValidation(inputCheckSubnwkId.value, inputCheckSubnwkId, $event);trimValue($event)"
               autocomplete="off"/>
        <div class="alert alert-danger alert-validate error-validate"
             *ngIf="haveError">{{errorMessageSubnetworkId}}
        </div>
      </div>
    </div>
  </div>

  <div class="select-edit-btn-area" *ngIf="isAdmin">
    <i *ngIf="isAdmin"
       class="fa fa-edit transition text-tooltip"
       aria-hidden="true"
       title-popup="Edit"
       (click)="inputOnClick()"
       [hidden]="inputIsHidden"></i>

    <button class="transition text-tooltip tooltip-edit"
            [hidden]="!inputIsHidden"
            (click)="inputOnSave()"
            [disabled]="haveError"
            onclick=""
            title-popup="Save">
      <i class="fa fa-check"
         [ngClass]="{'disabled':haveError}"
         aria-hidden="true"></i>
    </button>

    <button class="transition text-tooltip tooltip-edit"
            title-popup="Cancel"
            [hidden]="!inputIsHidden"
            (click)="inputOnCancel(inputCheck)">
      <i class="fa fa-times"
         aria-hidden="true"></i>
    </button>
  </div>
</div>

<div class="alert alert-danger alert-validate error-validate"
     *ngIf="haveError">{{errorMessage}}
</div>
